import { makeStyles } from '@material-ui/core/styles';
import { BorderBottom } from '@material-ui/icons';

export default makeStyles(theme => ({
  dashboardPage: {},
  logo: {
    width: 180,
  },
  layout: {
    display: 'flex',
    width: '100%',
    height: 'fit-content',
    justifyContent: 'start',
    flexDirection: 'column',
    paddingRight: '10px',
    gap: '5px',
  },
  content: {
    overflow: 'scroll',
    display: 'flex',
    width: '100%',
    justifyContent: 'start',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
    height: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(1, 1fr)',
    },
    padding: '5px',
  },

  card: {
    background: '#fff',
    borderBottom: 'solid 6px #F97A00',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'start',
    borderRadius: '10px',
    border: '0.5px solid rgba(0, 0, 0, 0.10)',
    boxShadow: '0px 4px 10px 0px rgba(166, 193, 211, 0.60)',
    minWidth: '20.81vh',
    minHeight: '12.81vh',
    maxWidth: 'fit-content',
    maxHeight: 'fit-content',

    padding: '10px',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      minHeight: 'fit-content',
      justifyContent: 'center',
      paddingTop: '20px',
      paddingBottom: '20px',
    },
    '&:hover': {
      boxShadow: '0px 8px 20px 0px rgba(166, 193, 211, 0.65)',
    },
  },

  cardDark: {
    background: '#2F2F2F',
    borderBottom: 'solid 6px #A6C1D3',
    boxShadow: ' 0px 4px 10px 0px rgba(166, 193, 211, 0.30)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'start',
    borderRadius: '10px',
    border: '0.5px solid rgba(0, 0, 0, 0.10)',
    minWidth: '20.81vh',
    minHeight: '12.81vh',
    maxWidth: 'fit-content',
    maxHeight: 'fit-content',

    padding: '10px',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      minHeight: 'fit-content',
      justifyContent: 'center',
      paddingTop: '20px',
      paddingBottom: '20px',
    },
    '&:hover': {
      boxShadow: '0px 8px 20px 0px rgba(166, 193, 211, 0.65)',
    },
  },
  title: {
    fontSize: '0.70rem',
    color: '#292D32',
    fontWeight: 700,
    textTransform: 'uppercase',
    margin: 0,
  },
  titleDark: {
    fontSize: '0.70rem',
    color: '#ECECEC',
    fontWeight: 700,
    textTransform: 'uppercase',
    margin: 0,
  },
  nameCard: {
    fontSize: '1.300rem',
    color: '#F97A00',
    fontWeight: 800,
    letterSpacing: '3px',
    textTransform: 'uppercase',
    margin: 0,
    overflowWrap: 'break-word',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  nameCardDark: {
    fontSize: '1.300rem',
    color: '#A6C1D3',
    fontWeight: 800,
    letterSpacing: '3px',
    textTransform: 'uppercase',
    margin: 0,
    overflowWrap: 'break-word',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },

  sectionDiv: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  cardsDiv: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    // gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      gridTemplateColumns: 'repeat(1, 1fr)',
    },
  },

  modeDiv: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'end',
    alignItems: 'center',
    gap: '10px',
    paddingRight: '10px',
  },

  modeIcon: {
    display: 'flex',
    width: 'fit',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
  },
}));
